// tslint:disable: max-line-length
import { groupBy } from 'lodash';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import { ISelfAssessmentTemplate } from '../../app/@types/selfAssessment';

export const getDepartmentApi = async (filterCategories?: number[]) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  const { data: dataApi } = await axiosInstance.get(
    `${Env.API_URL}/customerAssessment/duplicatecategory/${selectedBrand}/${selectedHotel}?`
  );
  let data = dataApi;
  if (filterCategories) {
    data = dataApi.filter((o) =>
      filterCategories.includes(o.sourceTemplateCategoryId)
    );
  }
  const groupedData = groupBy(data, 'templateParentCategoryId');

  const categories = data.filter((m) => m.categoryType === 'category');
  const realData = categories.map((category) => {
    if (groupedData[category.id]) {
      category.subCategory = groupedData[category.id];
    }
    return category;
  });
  return { ...data, data: realData };
};

export const getAvailableTemplate = () => {
  const { selectedBrand } = userHotelDetails();
  return axiosInstance
    .get<
      ISelfAssessmentTemplate[]
    >(`${Env.API_URL}/brand/${selectedBrand}/getTemplates`)
    .then((response) => {
      return response.data;
    });
};
